import React from 'react';
import { ArrowDown, ArrowUpRight, Github, Linkedin } from 'lucide-react';
import { profileData } from '../utils/mockData';
import { ArunkubeSymbol } from './ArunkubeLogo';
import MissionControlRail from './MissionControlRail';

export default function InterstellarHero() {
  const moveScene = (event) => {
    if (event.pointerType === 'touch') return;
    const rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - .5;
    const y = (event.clientY - rect.top) / rect.height - .5;
    event.currentTarget.style.setProperty('--scene-tilt-x', `${(-y * 5).toFixed(2)}deg`);
    event.currentTarget.style.setProperty('--scene-tilt-y', `${(x * 5).toFixed(2)}deg`);
  };
  const resetScene = (event) => {
    event.currentTarget.style.setProperty('--scene-tilt-x', '0deg');
    event.currentTarget.style.setProperty('--scene-tilt-y', '0deg');
  };
  return <section className="space-hero" aria-labelledby="space-title">
    <div className="space-hero-grid">
      <div className="space-hero-copy">
        <p className="space-eyebrow"><span /> CLOUD NATIVE / PLATFORM ARCHITECTURE</p>
        <p className="space-intro">I make complex infra boring</p>
        <h1 id="space-title"><span>Arun</span><span>Bharathwaj<span className="space-period">.</span></span></h1>
        <h2>{profileData.title}</h2>
        <p className="space-description">{profileData.description}</p>
        <div className="space-actions"><a className="space-primary" href="#projects" data-pointer-label="Explore">Explore my work <ArrowUpRight size={19} /></a><a className="space-secondary" href="#contact">Let’s talk <ArrowUpRight size={18} /></a></div>
        <div className="space-socials"><a href={profileData.linkedin} target="_blank" rel="noopener noreferrer"><Linkedin size={15} /> LinkedIn <ArrowUpRight size={13} /></a><a href={profileData.github} target="_blank" rel="noopener noreferrer"><Github size={15} /> GitHub <ArrowUpRight size={13} /></a></div>
      </div>
      <div className="orbital-scene" aria-hidden="true" onPointerMove={moveScene} onPointerLeave={resetScene}>
        <div className="orbital-coordinates"><span>CONNECTED BY DESIGN</span></div>
        <div className="orbital-halo" />
        <div className="orbital-track track-one"><i /></div><div className="orbital-track track-two"><i /></div><div className="orbital-track track-three"><i /></div>
        <div className="orbital-core"><ArunkubeSymbol /></div>
        <div className="orbital-label-orbit orbit-cloud"><div className="orbital-label">CLOUD NATIVE</div></div>
        <div className="orbital-label-orbit orbit-platform"><div className="orbital-label">PLATFORM</div></div>
        <div className="orbital-label-orbit orbit-modern"><div className="orbital-label">MODERNIZATION</div></div>
        <div className="orbital-caption"><span className="orbital-dot" /> Independent systems. One clear architecture.</div>
      </div>
    </div>
    <MissionControlRail />
    <div className="space-hero-bottom"><p>{profileData.subtitle}</p><a href="#about">Enter the portfolio <ArrowDown size={16} /></a></div>
  </section>;
}
